<template>
    <div class="card" v-if="getActionSpecials">
        <div class="card-header d-flex justify-content-between">
            <span v-if="reg.action === 'update'" style="color: #000"
                ><b>{{ $t("lang.label_edit") }} </b> {{ reg.day }}</span
            ><span v-else
                ><b>{{ btnName }}</b> {{ $t("lang.label_spcl") }}</span
            >
        </div>

        <div class="card-body">
            <div class="load" v-if="isLoading"><loader></loader></div>
            <form class="form-style" @submit.prevent="SaveForm">
                <div class="form-group col-md-12">
                    <div
                        class="d-flex align-items-center justify-content-center"
                        style="margin-top: 0px"
                    >
                        <button type="submit" class="btn btn-success btn-block">
                            {{ btnName }}
                        </button>
                        <button
                            type="button"
                            class="btn btn-primary btn-block"
                            style="margin-top: 0px; margin-left: 10px"
                            @click="CancelForm"
                        >
                            {{ $t("lang.label_cancel") }}
                        </button>
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-12">
                        <label for="title">{{ $t("lang.label_title") }}:</label>
                        <input
                            type="text"
                            class="form-control"
                            id="title"
                            v-model="reg.title"
                            required
                        />
                    </div>
                    <div class="form-group col-md-12">
                        <label for="name">{{ $t("lang.label_price") }}:</label>
                        <input
                            type="text"
                            class="form-control"
                            id="name"
                            v-model="reg.price"
                        />
                    </div>
                    <div class="form-group col-md-12">
                        <label for="name">{{ $t("lang.label_description") }}:</label>
                        <vue-editor
                            id="editor1"
                            class="editordet"
                            v-model="reg.description"
                            style="width: 100%"
                            :editor-toolbar="customToolbar"
                        />
                    </div>
                    <div class="form-group col-md-12">
                        <div
                            class="d-flex align-items-center justify-content-center"
                            style="margin-top: 17px"
                        >
                            <button type="submit" class="btn btn-success btn-block">
                                {{ btnName }}
                            </button>
                            <button
                                type="button"
                                class="btn btn-primary btn-block"
                                style="margin-top: 0px; margin-left: 10px"
                                @click="CancelForm"
                            >
                                {{ $t("lang.label_cancel") }}
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
        <notifications group="noti" position="top right" style="margin-top: 50px">
        </notifications>
    </div>
</template>
<script>
import Loader from "@/components/shared/Loader.vue";
import axios from "axios";
import { VueEditor } from "vue2-editor";
import { mapGetters } from "vuex";
import { mapState } from "vuex";
export default {
    name: "formSpecials",
    components: {
        Loader,
        VueEditor,
    },
    data () {
        return {
            isLoading: false,
            reg: {
                action: "create",
                btnName: window.lang2.label_add,
                id: null,
                title: "",
                description: "",
                price: 0,
            },
            dataActual: {},
            days: [
                { name: "Sunday" },
                { name: "Monday" },
                { name: "Tuesday" },
                { name: "Wednesday" },
                { name: "Thursday" },
                { name: "Friday" },
                { name: "Saturday" },
            ],
            btnName: "Guardar",
            formAvailable: true,
            customToolbar: [
                ["bold", "italic", "underline", "strike"], // toggled buttons
                [
                    { align: "" },
                    { align: "center" },
                    { align: "right" },
                    { align: "justify" }
                ],
                [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
                [{ color: [] }, { background: [] }], // dropdown with defaults from theme
                // ["link", "image", "video"],
                ["link"],
                ["clean"] // remove formatting button
            ],
        }
    },
    mounted () {
        if (this.currentData !== null) {
            this.reg.action = "update";
            this.btnName = window.lang2.label_up;
            this.reg.id = this.specialItemCurrent.id;
            this.reg.day = this.specialItemCurrent.day;
            this.reg.title = this.specialItemCurrent.title;
            this.reg.description = (this.specialItemCurrent.description!=null && this.specialItemCurrent.description!='null') ? this.specialItemCurrent.description : '';
            if (this.specialItemCurrent.price === "null") {
                this.reg.price = "";
            } else {
                this.reg.price = this.specialItemCurrent.price;
            }
        }
    },
    methods: {
        CancelForm() {
            this.$store.commit("SET_ACTIONS_SPECIALS", false);
        },
        clearInputs() {
            this.btnName = window.lang2.label_add;
            this.reg.id = null;
            this.reg.action = "create";
            this.reg.title = "";
            this.reg.description = "";
            this.reg.price = "";
        },
        uploadFile(e) {
            this.reg.image = e.target.files[0];
        },
        SaveForm() {
            this.$store.commit("SET_ACTIONS_SPECIALS", false);
            this.$store.commit("SET_SPECIALS_LISTS", []);
            //this.$store.commit('SET_ACTIONS_SPECIALS', true);
            this.isLoading = true;
            let status = 0;
            if (this.reg.status) {
                status = 1;
            }
            let fileSendHeader = {
                headers: { "Content-Type": "multipart/form-data" },
            };
            let formData = new FormData();
            formData.append("id", this.reg.id);
            formData.append("title", this.reg.title);
            formData.append("description", this.reg.description);
            formData.append("price", this.reg.price);
            formData.append("org_id", window.localuserdata);
            formData.append("user_id", window.localAccountID);
            if (this.reg.action === "update") {
                window.master
                    .post("menu/specials/update", formData, fileSendHeader)
                    .then((response) => {
                        console.log(response);

                        let esp = Array(
                            "Domingo",
                            "Lunes",
                            "Martes",
                            "Miercoles",
                            "Jueves",
                            "Viernes",
                            "Sabado"
                        );
                        let ing = Array(
                            "Sunday",
                            "Monday",
                            "Tuesday",
                            "Wednesday",
                            "Thursday",
                            "Friday",
                            "Saturday"
                        );
                        let res = Array();
                        let count = 0;
                        let d = response.data.result;
                        console.log("update", d);
                        if (window.lang2.label_IE === 1 || window.lang2.label_IE === "1") {
                            for (let is in d) {
                                if (ing[count] === d[is].day) {
                                    if (count > 0) {
                                        res.push({
                                            created_at: d[is].created_at,
                                            date: d[is].date,
                                            day: esp[count],
                                            description: d[is].description,
                                            id: d[is].id,
                                            image: d[is].image,
                                            org_id: d[is].org_id,
                                            price: d[is].price,
                                            status: d[is].status,
                                            title: d[is].title,
                                            updated_at: d[is].updated_at,
                                            user_id: d[is].user_id,
                                            is_files: d[is].is_files,
                                        });
                                    }
                                }
                                count++;
                            }
                            res.push({
                                created_at: d[0].created_at,
                                date: d[0].date,
                                day: esp[0],
                                description: d[0].description,
                                id: d[0].id,
                                image: d[0].image,
                                org_id: d[0].org_id,
                                price: d[0].price,
                                status: d[0].status,
                                title: d[0].title,
                                updated_at: d[0].updated_at,
                                user_id: d[0].user_id,
                                is_files: d[0].is_files,
                            });
                        } else {
                            for (let is in d) {
                                if (ing[count] === d[is].day) {
                                    if (count > 0) {
                                        res.push({
                                            created_at: d[is].created_at,
                                            date: d[is].date,
                                            day: ing[count],
                                            description: d[is].description,
                                            id: d[is].id,
                                            image: d[is].image,
                                            org_id: d[is].org_id,
                                            price: d[is].price,
                                            status: d[is].status,
                                            title: d[is].title,
                                            updated_at: d[is].updated_at,
                                            user_id: d[is].user_id,
                                            is_files: d[is].is_files,
                                        });
                                    }
                                }
                                count++;
                            }
                            res.push({
                                created_at: d[0].created_at,
                                date: d[0].date,
                                day: ing[0],
                                description: d[0].description,
                                id: d[0].id,
                                image: d[0].image,
                                org_id: d[0].org_id,
                                price: d[0].price,
                                status: d[0].status,
                                title: d[0].title,
                                updated_at: d[0].updated_at,
                                user_id: d[0].user_id,
                                is_files: d[0].is_files,
                            });
                        }
                        console.log(res);
                        this.$store.commit("SET_SPECIALS_LISTS", res);
                        //this.$store.commit('SET_ACTIONS_SPECIALS', false);

                        this.isLoading = false;

                        let add = { add: true };
                        let data = response.data.result;
                        this.$store.commit("SET_CURRENT_SPECIALS", { ...data, ...add });
                        this.clearInputs();
                        this.btnName = window.lang2.label_saved;
                        this.$notify({
                            group: "noti",
                            title: window.lang2.label_up,
                            type: "success",
                            text: window.lang2.msj_upd_sful,
                        });
                    })
                    .catch((error) => {
                        this.isLoading = false;
                        this.btnName = window.lang2.label_saved;
                    });
            }
        },
    },
    computed: {
        currentData() {
            return this.$store.getters.specialItemCurrent;
        },
        getActionSpecials() {
            return this.$store.getters.getActionSpecials;
        },
        //...mapState(['SpecialsItemActive']),
        ...mapGetters(["specialItemCurrent"]),
    },
    watch: {
        specialItemCurrent() {
            if (this.specialItemCurrent.add === true) {
                this.clearInputs();
            } else {
                this.reg.action = "update";
                this.btnName = window.lang2.label_up;
                this.reg.day = this.specialItemCurrent.day;
                this.reg.id = this.specialItemCurrent.id;
                this.reg.title = this.specialItemCurrent.title;
                this.reg.description = this.specialItemCurrent.description;
                this.reg.price = this.specialItemCurrent.price;
            }
        },
    },
}
</script>
<style lang="scss" scoped>
@media (min-width: 1366px) {
    .aside-special .card {
        margin-left: 0px !important;
    }
}
#editor1 {
    height: 450px !important;
}

.disabledForm {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #ffffffba;
    z-index: 10;
    display: flex;
    justify-content: center;
    align-items: center;
    span {
        width: 150px;
        text-align: center;
        color: #000;
        background-color: #fff;
        padding: 20px;
    }
}
.load {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #ffffff8c;
    z-index: 10;
}
.form-style {
    .form-control {
        border: 1px solid #bfbfbf;
    }
    .form-group {
        margin-bottom: 0.5rem;
    }
}
.swiches {
    .switch {
        position: relative;
        display: inline-block;
        width: 40px;
        height: 22px;
    }

    .switch input {
        opacity: 0;
        width: 0;
        height: 0;
    }

    /* The slider */
    .slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #ccc;
        -webkit-transition: 0.4s;
        transition: 0.4s;
    }

    .slider:before {
        position: absolute;
        content: "";
        height: 15px;
        width: 15px;
        left: 4px;
        bottom: 4px;
        background-color: white;
        -webkit-transition: 0.4s;
        transition: 0.4s;
    }

    input:checked + .slider {
        background-color: #2196f3;
    }

    input:focus + .slider {
        box-shadow: 0 0 1px #2196f3;
    }

    input:checked + .slider:before {
        -webkit-transform: translateX(17px);
        -ms-transform: translateX(17px);
        transform: translateX(17px);
    }

    /* Rounded sliders */
    .slider.round {
        border-radius: 34px;
    }

    .slider.round:before {
        border-radius: 50%;
    }
}
</style>
